import React, { createElement, createRef, Component, createContext, useContext, useEffect, useState, useRef } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics$ = function extendStatics$1(d, b) {
  _extendStatics$ = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics$(d, b);
};

function __extends$1(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics$(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __spreadArray(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var EnhancedTextarea =
/** @class */
function (_super) {
  __extends(EnhancedTextarea, _super);

  function EnhancedTextarea(props) {
    var _this = _super.call(this, props) || this;

    _this.textareaRef = createRef();
    _this.state = {
      value: props.value || props.defaultValue
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    return _this;
  }

  Object.defineProperty(EnhancedTextarea.prototype, "textarea", {
    get: function get() {
      return this.textareaRef.current;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EnhancedTextarea.prototype, "value", {
    get: function get() {
      return this.textarea.value;
    },
    set: function set(v) {
      this.textarea.value = v;
      this.onChange();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EnhancedTextarea.prototype, "selectedText", {
    get: function get() {
      return this.textarea.value.substring(this.textarea.selectionStart, this.textarea.selectionEnd);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EnhancedTextarea.prototype, "selectedFromLineStart", {
    get: function get() {
      var lineStart = this.value.substring(0, this.selectionStart).lastIndexOf('\n') + 1;
      return this.value.substring(lineStart, this.selectionStart);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EnhancedTextarea.prototype, "selectionStart", {
    get: function get() {
      return this.textarea.selectionStart;
    },
    set: function set(position) {
      this.textarea.selectionStart = position;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EnhancedTextarea.prototype, "selectionEnd", {
    get: function get() {
      return this.textarea.selectionEnd;
    },
    set: function set(position) {
      this.textarea.selectionEnd = position;
    },
    enumerable: false,
    configurable: true
  });

  EnhancedTextarea.prototype.focus = function () {
    this.textarea.focus();
  };

  EnhancedTextarea.prototype.replaceSelectedText = function (text) {
    var originalSelectionStart = this.textarea.selectionStart;
    var originalSelectionEnd = this.textarea.selectionEnd;
    this.replaceText({
      from: originalSelectionStart,
      text: text,
      to: originalSelectionEnd
    });
    this.onChange();
  };

  EnhancedTextarea.prototype.select = function (_a) {
    var from = _a.from,
        to = _a.to,
        length = _a.length;
    this.textarea.setSelectionRange(from, to || from + (length || 0));
  };

  EnhancedTextarea.prototype.putCursorTo = function (location) {
    this.textarea.selectionEnd = location || 0;
  };

  EnhancedTextarea.prototype.replaceText = function (_a) {
    var text = _a.text,
        from = _a.from,
        to = _a.to;
    var textLeft = this.textarea.value.substring(0, from);
    var textRight = this.textarea.value.substring(to);
    this.textarea.value = "" + textLeft + text + textRight;
    this.textarea.selectionEnd = from + text.length;
    this.onChange();
  };

  EnhancedTextarea.prototype.toggleTemplate = function (template) {
    this.focus();
    var selectionStart = this.selectionStart;

    if (this.selectedText === template) {
      this.replaceSelectedText('');
    } else {
      this.replaceSelectedText(template);
      this.select({
        from: selectionStart,
        length: template.length
      });
    }
  };

  EnhancedTextarea.prototype.toggleMultipleLineTemplate = function (template) {
    this.focus();
    var selectionStart = this.selectionStart;

    if (this.selectedText === template) {
      this.replaceSelectedText('');
      this.replaceText({
        from: selectionStart - 1,
        text: '',
        to: template.length + 2
      });
    } else {
      this.replaceSelectedText("\n" + template + "\n");
      this.select({
        from: selectionStart + 1,
        length: template.length
      });
    }
  };

  EnhancedTextarea.prototype.toggleMultipleLineMarker = function (_a) {
    var prefix = _a.prefix,
        suffix = _a.suffix,
        defaultText = _a.defaultText;
    this.focus();
    var text = this.selectedText || defaultText;

    var _b = this,
        selectionStart = _b.selectionStart,
        selectionEnd = _b.selectionEnd;

    if (this.value.substr(selectionStart - prefix.length - 1, prefix.length) === prefix && this.value.substr(selectionEnd + 1, suffix.length) === suffix) {
      this.replaceText({
        from: selectionStart - prefix.length - 2,
        text: text === defaultText ? '' : text,
        to: selectionEnd + suffix.length + 2
      });

      if (text !== defaultText) {
        this.select({
          from: selectionStart - prefix.length - 2,
          length: text.length
        });
      }
    } else {
      this.replaceSelectedText("\n" + prefix + "\n" + text + "\n" + suffix + "\n");
      this.select({
        from: selectionStart + prefix.length + 2,
        length: text.length
      });
    }
  };

  EnhancedTextarea.prototype.toggleMarker = function (_a) {
    var prefix = _a.prefix,
        suffix = _a.suffix,
        defaultText = _a.defaultText;
    this.focus();
    var text = this.selectedText || defaultText;

    var _b = this,
        selectionStart = _b.selectionStart,
        selectionEnd = _b.selectionEnd;

    if (this.value.substr(selectionStart - prefix.length, prefix.length) === prefix && this.value.substr(selectionEnd, suffix.length) === suffix) {
      this.replaceText({
        from: selectionStart - prefix.length,
        text: text === defaultText ? '' : text,
        to: selectionEnd + suffix.length
      });

      if (text !== defaultText) {
        this.select({
          from: selectionStart - prefix.length,
          length: text.length
        });
      }
    } else {
      this.replaceSelectedText("" + prefix + text + suffix);
      this.select({
        from: selectionStart + prefix.length,
        length: text.length
      });
    }
  };

  EnhancedTextarea.prototype.append = function (content) {
    this.value += content;
  };

  EnhancedTextarea.prototype.toggleLineMarker = function (marker) {
    this.focus();
    var text = this.value;

    var _a = this,
        selectionStart = _a.selectionStart,
        selectionEnd = _a.selectionEnd;

    var firstLineStart = text.substring(0, selectionStart).lastIndexOf('\n') + 1;
    var otherLineMarkers = (this.props.lineMarkers || []).filter(function (it) {
      return it !== marker;
    });
    var newText = text.substring(firstLineStart, selectionEnd).split('\n').map(function (line) {
      if (line.indexOf(marker) === 0) {
        return line.substring(marker.length);
      }

      var currentMarker = otherLineMarkers.find(function (it) {
        return line.indexOf(it) === 0;
      });

      if (currentMarker) {
        return marker + line.substring(currentMarker.length);
      }

      return marker + line;
    }).join('\n');
    this.replaceText({
      from: firstLineStart,
      text: newText,
      to: selectionEnd
    });
  };

  EnhancedTextarea.prototype.render = function () {
    var props = this.props;
    var rows = Math.max((this.state.value || '').split('\n').length, props.rows || 0);
    return createElement("textarea", {
      id: props.id,
      className: props.className,
      ref: this.textareaRef,
      style: props.style,
      rows: rows,
      wrap: "virtual",
      autoComplete: "off",
      defaultValue: props.defaultValue,
      value: props.value,
      onKeyPress: props.onKeyPress,
      onKeyDown: this.onKeyDown,
      onChange: this.onChange,
      autoFocus: props.autoFocus,
      placeholder: props.placeholder,
      onPaste: props.onPaste,
      onPasteCapture: props.onPasteCapture,
      onCopy: props.onCopy,
      onCopyCapture: props.onCopyCapture,
      maxLength: props.maxLength
    });
  };

  EnhancedTextarea.prototype.onChange = function () {
    if (this.props.onChange) {
      this.props.onChange(this.textareaRef.current.value);
    }

    this.setState({
      value: this.textareaRef.current.value
    });
  };

  EnhancedTextarea.prototype.onKeyDown = function (e) {
    if (e.key === 'Enter') {
      var startText_1 = this.selectedFromLineStart;
      var marker = (this.props.lineMarkers || []).find(function (m) {
        return startText_1.startsWith(m);
      });

      if (marker) {
        this.replaceSelectedText("\n" + marker);
        e.preventDefault();
      }
    } else {
      if (this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }
    }
  };

  EnhancedTextarea.defaultProps = {
    autoFocus: false,
    className: undefined,
    defaultValue: undefined,
    id: undefined,
    maxLength: undefined,
    lineMarkers: [],
    onChange: undefined,
    onKeyDown: undefined,
    onKeyPress: undefined,
    placeholder: undefined,
    rows: 5,
    style: undefined,
    value: undefined
  };
  return EnhancedTextarea;
}(Component);

var EditContext = createContext({});

var EditorMarker = function EditorMarker(props) {
  var _a = useContext(EditContext),
      mark = _a.mark,
      markLine = _a.markLine,
      registerLineMarker = _a.registerLineMarker,
      template = _a.template;

  useEffect(function () {
    if (config.type === 'line-marker') {
      registerLineMarker(config.marker);
    }
  });
  var config = props.config;
  var handler;

  switch (config.type) {
    case 'marker':
      handler = function handler() {
        return mark(config.prefix, config.suffix, config.defaultText || '', config.multipleLine || false);
      };

      break;

    case 'line-marker':
      handler = function handler() {
        return markLine(config.marker);
      };

      break;

    case 'template':
      handler = function handler() {
        return template(config.template, config.multipleLine || false);
      };

      break;

    case 'component':
      handler = undefined;
      break;
  }

  return createElement("span", {
    onClick: handler,
    className: classnames('tme-menu-item-inner', props.className)
  }, config.name);
};

var util = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isNavigator = exports.isBrowser = exports.off = exports.on = exports.noop = void 0;

  var noop = function noop() {};

  exports.noop = noop;

  function on(obj) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    if (obj && obj.addEventListener) {
      obj.addEventListener.apply(obj, args);
    }
  }

  exports.on = on;

  function off(obj) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    if (obj && obj.removeEventListener) {
      obj.removeEventListener.apply(obj, args);
    }
  }

  exports.off = off;
  exports.isBrowser = typeof window !== 'undefined';
  exports.isNavigator = typeof navigator !== 'undefined';
});
unwrapExports(util);
util.isNavigator;
util.isBrowser;
util.off;
util.on;
util.noop;
var useClickAway_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var defaultEvents = ['mousedown', 'touchstart'];

  var useClickAway = function useClickAway(ref, onClickAway, events) {
    if (events === void 0) {
      events = defaultEvents;
    }

    var savedCallback = React.useRef(onClickAway);
    React.useEffect(function () {
      savedCallback.current = onClickAway;
    }, [onClickAway]);
    React.useEffect(function () {
      var handler = function handler(event) {
        var el = ref.current;
        el && !el.contains(event.target) && savedCallback.current(event);
      };

      for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var eventName = events_1[_i];
        util.on(document, eventName, handler);
      }

      return function () {
        for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
          var eventName = events_2[_i];
          util.off(document, eventName, handler);
        }
      };
    }, [events, ref]);
  };

  exports.default = useClickAway;
});
var useClickAway = unwrapExports(useClickAway_1);
var arrowIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNy40MSA4LjU5TDEyIDEzLjE3bDQuNTktNC41OEwxOCAxMGwtNiA2LTYtNiAxLjQxLTEuNDF6Ii8+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyNEgwVjB6Ii8+PC9zdmc+';

var EditorMenuDropdown = function EditorMenuDropdown(props) {
  var config = props.config;

  var _a = useState(false),
      show = _a[0],
      setShow = _a[1];

  var _b = useState(0),
      index = _b[0],
      setIndex = _b[1];

  var focus = useContext(EditContext).focus;
  var ref = useRef(null);
  useClickAway(ref, function () {
    setShow(false);
  });
  return createElement("li", {
    ref: ref,
    className: classnames('tme-menu-item tme-dropdown', props.className),
    title: config.markers[index].title
  }, createElement(EditorMarker, {
    config: config.markers[index]
  }), createElement("span", {
    className: "tme-dropdown-arrow",
    onClick: function onClick() {
      setShow(!show);

      if (!show) {
        focus();
      }
    }
  }, createElement("img", {
    alt: "",
    src: arrowIcon
  })), createElement("div", {
    className: classnames('tme-dropdown-content', {
      show: show
    })
  }, createElement("ul", null, config.markers.map(function (marker, i) {
    return createElement("li", {
      className: "tme-menu-item tme-dropdown-item",
      key: marker.key,
      onClick: function onClick() {
        setIndex(i);
        setShow(false);
      },
      title: marker.title
    }, createElement(EditorMarker, {
      config: marker
    }));
  }))));
};

var editIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMyAxNy4yNVYyMWgzLjc1TDE3LjgxIDkuOTRsLTMuNzUtMy43NUwzIDE3LjI1ek0yMC43MSA3LjA0Yy4zOS0uMzkuMzktMS4wMiAwLTEuNDFsLTIuMzQtMi4zNGMtLjM5LS4zOS0xLjAyLS4zOS0xLjQxIDBsLTEuODMgMS44MyAzLjc1IDMuNzUgMS44My0xLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=';
var previewIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDQuNUM3IDQuNSAyLjczIDcuNjEgMSAxMmMxLjczIDQuMzkgNiA3LjUgMTEgNy41czkuMjctMy4xMSAxMS03LjVjLTEuNzMtNC4zOS02LTcuNS0xMS03LjV6TTEyIDE3Yy0yLjc2IDAtNS0yLjI0LTUtNXMyLjI0LTUgNS01IDUgMi4yNCA1IDUtMi4yNCA1LTUgNXptMC04Yy0xLjY2IDAtMyAxLjM0LTMgM3MxLjM0IDMgMyAzIDMtMS4zNCAzLTMtMS4zNC0zLTMtM3oiLz48L3N2Zz4=';
var helpIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTEgMThoMnYtMmgtMnYyem0xLTE2QzYuNDggMiAyIDYuNDggMiAxMnM0LjQ4IDEwIDEwIDEwIDEwLTQuNDggMTAtMTBTMTcuNTIgMiAxMiAyem0wIDE4Yy00LjQxIDAtOC0zLjU5LTgtOHMzLjU5LTggOC04IDggMy41OSA4IDgtMy41OSA4LTggOHptMC0xNGMtMi4yMSAwLTQgMS43OS00IDRoMmMwLTEuMS45LTIgMi0yczIgLjkgMiAyYzAgMi0zIDEuNzUtMyA1aDJjMC0yLjI1IDMtMi41IDMtNSAwLTIuMjEtMS43OS00LTQtNHoiLz48L3N2Zz4=';
var linkIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTMuOSAxMmMwLTEuNzEgMS4zOS0zLjEgMy4xLTMuMWg0VjdIN2MtMi43NiAwLTUgMi4yNC01IDVzMi4yNCA1IDUgNWg0di0xLjlIN2MtMS43MSAwLTMuMS0xLjM5LTMuMS0zLjF6TTggMTNoOHYtMkg4djJ6bTktNmgtNHYxLjloNGMxLjcxIDAgMy4xIDEuMzkgMy4xIDMuMXMtMS4zOSAzLjEtMy4xIDMuMWgtNFYxN2g0YzIuNzYgMCA1LTIuMjQgNS01cy0yLjI0LTUtNS01eiIvPjwvc3ZnPg==';
var orderedListIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMiAxN2gydi41SDN2MWgxdi41SDJ2MWgzdi00SDJ2MXptMS05aDFWNEgydjFoMXYzem0tMSAzaDEuOEwyIDEzLjF2LjloM3YtMUgzLjJMNSAxMC45VjEwSDJ2MXptNS02djJoMTRWNUg3em0wIDE0aDE0di0ySDd2MnptMC02aDE0di0ySDd2MnoiLz48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PC9zdmc+';
var unorderedListIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNCAxMC41Yy0uODMgMC0xLjUuNjctMS41IDEuNXMuNjcgMS41IDEuNSAxLjUgMS41LS42NyAxLjUtMS41LS42Ny0xLjUtMS41LTEuNXptMC02Yy0uODMgMC0xLjUuNjctMS41IDEuNVMzLjE3IDcuNSA0IDcuNSA1LjUgNi44MyA1LjUgNiA0LjgzIDQuNSA0IDQuNXptMCAxMmMtLjgzIDAtMS41LjY4LTEuNSAxLjVzLjY4IDEuNSAxLjUgMS41IDEuNS0uNjggMS41LTEuNS0uNjctMS41LTEuNS0xLjV6TTcgMTloMTR2LTJIN3Yyem0wLTZoMTR2LTJIN3Yyem0wLTh2MmgxNFY1SDd6Ii8+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyNEgwVjB6Ii8+PC9zdmc+';
var en = {
  header1: "<h1></h1>",
  header2: "<h2></h2>",
  header3: "<h3></h3>",
  orderedList: "Ordered List",
  unorderedList: "Unordered List",
  link: "Link",
  preview: "Preview",
  edit: "Edit",
  bold: "Bold",
  italic: "Italic",
  strikethrough: "Strikethrough",
  blockquote: "Blockquote",
  inlineCode: "Inline code",
  code: "Code"
};
var zh = {
  header1: "<h1></h1>",
  header2: "<h2></h2>",
  header3: "<h3></h3>",
  orderedList: "有序列表",
  unorderedList: "无序列表",
  link: "链接",
  preview: "预览",
  edit: "编辑",
  bold: "加粗",
  italic: "斜体",
  strikethrough: "划线",
  blockquote: "引用",
  inlineCode: "内置代码",
  code: "代码"
};
var languages = {
  en: en,
  zh: zh
};

var EditorMenu = function EditorMenu(props) {
  var toggleEdit = props.toggleEdit,
      isEditing = props.isEditing,
      language = props.language,
      readOnly = props.readOnly;
  var markers = props.markers;

  if (!markers) {
    markers = [{
      key: 'header',
      markers: [{
        key: 'header',
        markers: [{
          key: 'h1',
          marker: '# ',
          name: createElement("b", null, "H1"),
          title: languages[language].header1,
          type: 'line-marker'
        }, {
          key: 'h2',
          marker: '## ',
          name: createElement("b", null, "H2"),
          title: languages[language].header2,
          type: 'line-marker'
        }, {
          key: 'h3',
          marker: '### ',
          name: createElement("b", null, "H3"),
          title: languages[language].header3,
          type: 'line-marker'
        }],
        type: 'dropdown'
      }]
    }, {
      key: 'text',
      markers: [{
        key: 'text',
        markers: [{
          defaultText: 'bold',
          key: 'bold',
          name: createElement("b", null, languages[language].bold),
          prefix: '**',
          suffix: '**',
          title: languages[language].bold,
          type: 'marker'
        }, {
          defaultText: 'italic',
          key: 'italic',
          name: createElement("i", null, languages[language].italic),
          prefix: '*',
          suffix: '*',
          title: languages[language].italic,
          type: 'marker'
        }, {
          defaultText: 'strikethrough',
          key: 'strikethrough',
          name: createElement("del", null, languages[language].strikethrough),
          prefix: '~~',
          suffix: '~~',
          title: languages[language].strikethrough,
          type: 'marker'
        }, {
          key: 'blockquote',
          marker: '> ',
          name: languages[language].blockquote,
          title: languages[language].blockquote,
          type: 'line-marker'
        }, {
          defaultText: 'inline code',
          key: 'inline-code',
          name: languages[language].inlineCode,
          prefix: '`',
          suffix: '`',
          title: languages[language].inlineCode,
          type: 'marker'
        }, {
          defaultText: 'code',
          key: 'code',
          multipleLine: true,
          name: languages[language].code,
          prefix: '```',
          suffix: '```',
          title: languages[language].code,
          type: 'marker'
        }],
        type: 'dropdown'
      }]
    }, {
      key: 'list',
      markers: [{
        key: 'unordered-list',
        marker: '* ',
        name: createElement("img", {
          alt: "",
          src: unorderedListIcon
        }),
        title: languages[language].unorderedList,
        type: 'line-marker'
      }, {
        key: 'ordered-list',
        marker: '1. ',
        name: createElement("img", {
          alt: "",
          src: orderedListIcon
        }),
        title: languages[language].orderedList,
        type: 'line-marker'
      }]
    }, {
      key: 'additional',
      markers: [{
        defaultText: 'text',
        key: 'link',
        name: createElement("img", {
          alt: "",
          src: linkIcon
        }),
        prefix: '[',
        suffix: '](url)',
        title: languages[language].link,
        type: 'marker'
      }]
    }];
  }

  return createElement("div", {
    className: "tme-menu"
  }, isEditing && markers.map(function (group) {
    return createElement("ul", {
      key: group.key,
      className: "tme-menu-group left"
    }, group.markers.map(function (marker) {
      switch (marker.type) {
        case 'dropdown':
          return createElement(EditorMenuDropdown, {
            key: marker.key,
            config: marker
          });

        default:
          return createElement("li", {
            className: "tme-menu-item",
            key: marker.key,
            title: marker.title
          }, createElement(EditorMarker, {
            config: marker
          }));
      }
    }));
  }), createElement("ul", {
    className: "tme-menu-group right"
  }, createElement("li", {
    className: "tme-menu-item tme-link"
  }, createElement("a", {
    href: "https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet",
    target: "_blank"
  }, createElement("img", {
    alt: "",
    src: helpIcon
  }))), !readOnly && createElement("li", {
    className: "tme-menu-item",
    onClick: function onClick() {
      return toggleEdit();
    },
    title: isEditing ? languages[language].preview : languages[language].edit
  }, createElement("span", {
    className: "tme-menu-item-inner"
  }, createElement("img", {
    alt: "",
    src: isEditing ? previewIcon : editIcon
  })))));
};

var TextareaMarkdownEditor =
/** @class */
function (_super) {
  __extends$1(TextareaMarkdownEditor, _super);

  function TextareaMarkdownEditor(props) {
    var _this = _super.call(this, props) || this;

    _this.textareaRef = createRef();
    _this.state = {
      edit: !props.readOnly,
      lineMarkers: [],
      value: props.defaultValue
    };
    _this.toggleEdit = _this.toggleEdit.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.focus = _this.focus.bind(_this);
    _this.mark = _this.mark.bind(_this);
    _this.markLine = _this.markLine.bind(_this);
    _this.registerLineMarker = _this.registerLineMarker.bind(_this);
    _this.markTemplate = _this.markTemplate.bind(_this);
    return _this;
  }

  TextareaMarkdownEditor.prototype.focus = function () {
    this.textareaRef.current.focus();
  };

  TextareaMarkdownEditor.prototype.append = function (content) {
    this.textareaRef.current.append(content);
  };

  TextareaMarkdownEditor.prototype.mark = function (prefix, suffix, defaultText, multipleLine) {
    if (multipleLine) {
      this.textareaRef.current.toggleMultipleLineMarker({
        prefix: prefix,
        suffix: suffix,
        defaultText: defaultText
      });
    } else {
      this.textareaRef.current.toggleMarker({
        prefix: prefix,
        suffix: suffix,
        defaultText: defaultText
      });
    }
  };

  TextareaMarkdownEditor.prototype.markLine = function (marker) {
    this.textareaRef.current.toggleLineMarker(marker);
  };

  TextareaMarkdownEditor.prototype.registerLineMarker = function (marker) {
    var index = this.state.lineMarkers.indexOf(marker);

    if (index < 0) {
      this.setState(_assign(_assign({}, this.state), {
        lineMarkers: __spreadArray(__spreadArray([], this.state.lineMarkers), [marker])
      }));
    }
  };

  TextareaMarkdownEditor.prototype.markTemplate = function (template, multipleLine) {
    if (multipleLine) {
      this.textareaRef.current.toggleMultipleLineTemplate(template);
    } else {
      this.textareaRef.current.toggleTemplate(template);
    }
  };

  TextareaMarkdownEditor.prototype.render = function () {
    var _a, _b;

    var _c = this.props.readOnly,
        readOnly = _c === void 0 ? false : _c;
    return createElement("div", {
      id: this.props.id,
      className: classnames('tme-container', this.props.className),
      style: this.props.style
    }, createElement(EditContext.Provider, {
      value: {
        focus: this.focus,
        mark: this.mark,
        markLine: this.markLine,
        registerLineMarker: this.registerLineMarker,
        template: this.markTemplate
      }
    }, createElement(EditorMenu, {
      markers: this.props.markers,
      readOnly: readOnly,
      language: this.props.language,
      isEditing: this.state.edit,
      toggleEdit: this.toggleEdit
    }), this.state.edit ? createElement(EnhancedTextarea, {
      id: this.props.textareaId,
      className: "tme-textarea",
      ref: this.textareaRef,
      rows: this.props.rows,
      maxLength: this.props.maxLength,
      style: this.props.textareaStyle,
      autoFocus: this.props.autoFocus,
      defaultValue: this.props.value ? undefined : this.state.value,
      value: this.props.value,
      onChange: this.onChange,
      onKeyDown: this.props.onKeyDown,
      onKeyPress: this.props.onKeyPress,
      lineMarkers: this.state.lineMarkers,
      onPaste: this.props.onPaste,
      onPasteCapture: this.props.onPasteCapture,
      onCopy: this.props.onCopy,
      onCopyCapture: this.props.onCopyCapture,
      placeholder: this.props.placeholder
    }) : createElement("div", {
      className: classnames('tme-viewer', this.props.viewerClassName),
      style: this.props.viewerStyle,
      dangerouslySetInnerHTML: {
        __html: this.props.readOnly ? this.props.doParse((_b = (_a = this.props.value) !== null && _a !== void 0 ? _a : this.state.value) !== null && _b !== void 0 ? _b : '') : this.textareaRef.current ? this.props.doParse(this.textareaRef.current.value) : ''
      }
    })));
  };

  TextareaMarkdownEditor.prototype.toggleEdit = function () {
    this.setState(_assign(_assign({}, this.state), {
      edit: !this.state.edit
    }));
  };

  TextareaMarkdownEditor.prototype.onChange = function (value) {
    this.setState(_assign(_assign({}, this.state), {
      value: value
    }));

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  TextareaMarkdownEditor.defaultProps = {
    language: 'en',
    readOnly: false,
    rows: 5
  };
  return TextareaMarkdownEditor;
}(Component);

export default TextareaMarkdownEditor;